/**
 * FileオブジェクトをBase64エンコードされたData URL文字列に変換する
 *
 * @param file - 変換対象のFileオブジェクト
 * @returns Base64エンコードされたData URL文字列を返すPromise
 *          ファイルが存在しない場合は空文字列を返す
 * @throws ファイルの読み込みに失敗した場合はエラーをrejectする
 *
 * @example
 * ```ts
 * const file = event.target.files[0];
 * const base64Url = await fileToUrlByBase64(file);
 * // base64Url: "data:image/png;base64,iVBORw0KGgo..."
 * ```
 */
export const fileToUrlByBase64 = (file: File): Promise<string> => {
  if (!file) {
    return Promise.resolve('');
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        resolve(result);
      } else {
        reject(new Error('ファイルの読み込み結果が不正です'));
      }
    };

    reader.onerror = () => {
      reject(reader.error || new Error('ファイルの読み込みに失敗しました'));
    };

    reader.readAsDataURL(file);
  });
};
